var exports = {
  "Gn": "GitHubAppGAPage__R5sHjz",
  "wT": "GitHubAppGAPage__spacer__xTQi-8",
  "mu": "GitHubAppGAPage__spacer--desktopOnly__WU7xzg",
  "wc": "GitHubAppGAPage__spacer--mobileOnly__pOBLd4",
  "t1": "GitHubAppGAPage__subNav__6Cs8UR",
};

module.exports = exports;
